import { cloneDeep } from 'lodash';
import { getFramework } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { isHttpUri } from '@/utils/file-kit';
import { getOrCreateScreenshotUrlCode, hydrateScreenshotUrlCode } from '@/utils/screenshot-url-kit';
import type { ITableLayer, ITableLayerProps } from '@/version-types';

export const getTableScreenshotFingerprintData = (layer: ITableLayer) => {
    const data = cloneDeep(layer.data) as ITableLayerProps;
    delete data.screenshotUrl;

    data.cells.forEach((row) => {
        row.forEach((cell) => {
            if (cell) {
                Reflect.deleteProperty(cell, '__renderId');
            }
        });
    });

    return {
        width: Math.floor(layer.width),
        height: Math.floor(layer.height),
        ...data,
    };
};

export const hydrateTableLayerScreenshotUrl = (layer: ITableLayer) => {
    layer.data.screenshotUrl = hydrateScreenshotUrlCode({
        fingerprintData: getTableScreenshotFingerprintData(layer),
        remoteUrl: layer.data.screenshotUrl,
    });
    return layer;
};

export const initializeTableLayerScreenshotUrl = (layer: ITableLayer) => {
    if (!layer.__runtime?.isInit && layer.data.screenshotUrl && isHttpUri(layer.data.screenshotUrl)) {
        hydrateTableLayerScreenshotUrl(layer);
    }
    layer.__runtime = {
        ...layer.__runtime,
        isInit: true,
    };
    return layer;
};

export const getTableLayerScreenshotUrlCode = async (identity: string, layer: ITableLayer) => {
    if (layer.width <= 0 || layer.height <= 0) return '';

    return getOrCreateScreenshotUrlCode({
        fingerprintData: getTableScreenshotFingerprintData(layer),
        createDataUrl: async () => {
            const canvas = await getFramework(identity).service.behavior.get(layer)?.getLayerImageAsync?.(layer, false);
            return canvas?.toDataURL();
        },
    });
};

/** 生成并上传表格截图，返回可持久化的远程地址。 */
export const getTableLayerScreenshotUrl = async (layer: ITableLayer, identity: string) => {
    const code = await getTableLayerScreenshotUrlCode(identity, layer);
    return code ? base64Kit.getRemoteUrlAsync(code) : '';
};
